import {
  CloudServerOutlined,
  CommentOutlined,
  DashboardOutlined,
  DollarOutlined,
  GatewayOutlined,
  GlobalOutlined,
  MailOutlined,
  ThunderboltOutlined,
  // AppstoreOutlined,
} from '@ant-design/icons'
import { APP_PREFIX_PATH } from 'configs/AppConfig'

const dashBoardNavTree = [
  {
    key: 'cloud',
    path: `${APP_PREFIX_PATH}`,
    title: 'Cloud',
    breadcrumb: false,
    isGroupTitle: true,
    submenu: [
      {
        key: 'dashboard',
        path: `${APP_PREFIX_PATH}`,
        title: 'sidenav.dashboard',
        icon: DashboardOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: 'vps',
        path: `${APP_PREFIX_PATH}/vps`,
        title: 'sidenav.vps',
        icon: CloudServerOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: 'e-mail',
        path: `${APP_PREFIX_PATH}/email`,
        title: 'E-mail',
        icon: MailOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: 'reverse-proxy',
        path: `${APP_PREFIX_PATH}/reverse-proxy`,
        title: 'sidenav.reverseproxy',
        icon: GatewayOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: 'domain',
        path: `${APP_PREFIX_PATH}/domain`,
        title: 'sidenav.domain',
        icon: GlobalOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: 'automation',
        path: `${APP_PREFIX_PATH}/automation`,
        title: 'Autoconfiguração',
        icon: ThunderboltOutlined,
        breadcrumb: false,
        submenu: [],
        role: ['13:BetaTester'],
      },
    ],
  },
  // {
  //   key: 'email',
  //   path: `${APP_PREFIX_PATH}/vps`,
  //   title: 'E-mail',
  //   icon: MailOutlined,
  //   breadcrumb: false,
  //   submenu: [],
  // },
  // {
  //   key: 'applilcation',
  //   path: `${APP_PREFIX_PATH}/vps`,
  //   title: 'Aplicações',
  //   icon: AppstoreOutlined,
  //   breadcrumb: false,
  //   submenu: [],
  // },
  {
    key: 'support',
    path: `${APP_PREFIX_PATH}`,
    title: 'sidenav.support',
    breadcrumb: false,
    isGroupTitle: true,
    submenu: [
      {
        key: 'billing-tickets',
        path: `${APP_PREFIX_PATH}/ticket`,
        title: 'sidenav.support.ticket',
        icon: CommentOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
  {
    key: 'billing',
    path: `${APP_PREFIX_PATH}`,
    title: 'sidenav.billing',
    breadcrumb: false,
    isGroupTitle: true,
    submenu: [
      {
        key: 'billing-wallet',
        path: `${APP_PREFIX_PATH}/wallet`,
        title: 'sidenav.billing.wallet',
        icon: DollarOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
]

const navigationConfig = [...dashBoardNavTree]

export default navigationConfig
